<i [className]="iconName"></i>
